module.exports = __webpack_public_path__ + "img/text-con-11.be26741e.png";